import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { useTranslation } from 'react-i18next';
import { Grid } from 'src/components/Grid';
import { Icon } from 'src/components/Icon';
import { Skeleton } from 'src/components/Skeleton';
import { Stack } from 'src/components/Stack';
import { Typography } from 'src/components/Typography';
import { Product } from 'src/models/product/_types';
import SwipeBox from 'src/shared/SwipeBox';

import { usePosContext } from '../PosContext';

import PosProductWrapper from './PosProductWrapper';
export const PosProductList = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'pointOfSale.productList',
  });
  const { getProductsPage, isLoadingProducts, handlePageChange, page, config } =
    usePosContext();

  if (isLoadingProducts) {
    return (
      <Grid
        container
        spacing={2}
        sx={{
          overflow: 'auto',
          scrollbarWidth: 'none',
          maxHeight: 'calc(100vh - 35vh)',
          width: '100%',
        }}
      >
        {Array.from({ length: 5 }).map((_, index) => (
          <Grid size={{ xs: 12, sm: 6, md: 6, lg: 4, xl: 3 }} key={index}>
            <Skeleton variant="rectangular" height={120} />
          </Grid>
        ))}
      </Grid>
    );
  }

  const products = getProductsPage();

  if (products.length === 0) {
    return (
      <Grid
        container
        spacing={2}
        flex={1}
        alignItems="center"
        justifyContent="center"
        width="100%"
        height="100%"
        bgcolor="background.level1"
        borderRadius={2}
      >
        <Stack spacing={2} alignItems="center">
          <Icon
            icon={icon({
              name: 'box',
              style: 'regular',
            })}
            size="large"
          />

          <Stack alignItems="center">
            <Typography variant="h6" color="text.primary" fontWeight={600}>
              {t('noProducts')}
            </Typography>
            <Typography
              variant="body1"
              color="text.secondary"
              textAlign="center"
              maxWidth={320}
            >
              {t('noProductsDescription')}
            </Typography>
          </Stack>
        </Stack>
      </Grid>
    );
  }

  const handleSwipeNextPage = () => {
    if (page === config?.config.length) return;
    handlePageChange(page + 1);

    handlePageChange;
  };
  const handleSwipePreviousPage = () => {
    if (page === 1) return;
    handlePageChange(page - 1);
  };

  return (
    <SwipeBox
      onSwipeLeft={handleSwipePreviousPage}
      onSwipeRight={handleSwipeNextPage}
    >
      <Grid
        container
        spacing={1}
        flex={1}
        alignContent="flex-start"
        width="100%"
        overflow="auto"
        sx={{
          scrollbarWidth: 'none',
        }}
      >
        {products.map((product) => {
          if (!product) return null;

          return (
            <PosProductWrapper
              key={product.name}
              product={product as Product}
            />
          );
        })}
      </Grid>
    </SwipeBox>
  );
};
